import {
  getDefaultEmailComposition,
  patchEmailComposition,
} from './helpers/emailUtils';
import type {
  InterviewCommunicationAction,
  InterviewCommunicationFormState,
} from './types';
import {
  COMMUNICATION_TAB_VALUES,
  INTERVIEW_EMAIL_SENDER_ORGANIZER_VALUE,
} from './types';

const emailWithOrganizerAsFrom = () =>
  patchEmailComposition(getDefaultEmailComposition(), {
    from: INTERVIEW_EMAIL_SENDER_ORGANIZER_VALUE,
  });

export const initialInterviewCommunicationFormState: InterviewCommunicationFormState =
  {
    activeSubTab: COMMUNICATION_TAB_VALUES[0],
    candidateCalendar: getDefaultEmailComposition(),
    candidateEmailEnabled: false,
    candidateEmail: emailWithOrganizerAsFrom(),
    candidateEmailAttachments: [],
    interviewerCalendar: getDefaultEmailComposition(),
    interviewerEmailEnabled: false,
    interviewerEmail: emailWithOrganizerAsFrom(),
    interviewerEmailAttachments: [],
    selfScheduleEnabled: true,
    selfSchedule: emailWithOrganizerAsFrom(),
    selfScheduleAttachments: [],
    candidateIcsEnabled: false,
    interviewerIcsEnabled: false,
  };

export function interviewCommunicationReducer(
  state: InterviewCommunicationFormState,
  action: InterviewCommunicationAction
): InterviewCommunicationFormState {
  switch (action.type) {
    case 'SET_ACTIVE_SUB_TAB':
      return { ...state, activeSubTab: action.payload };
    case 'SET_CANDIDATE_CALENDAR':
      return {
        ...state,
        candidateCalendar: action.payload,
      };
    case 'SET_CANDIDATE_EMAIL_ENABLED':
      return {
        ...state,
        candidateEmailEnabled: action.payload,
        ...(action.payload ? {} : { candidateEmailAttachments: [] }),
      };
    case 'SET_CANDIDATE_EMAIL':
      return {
        ...state,
        candidateEmail: action.payload,
      };
    case 'SET_CANDIDATE_EMAIL_ATTACHMENTS':
      return { ...state, candidateEmailAttachments: action.payload };
    case 'SET_INTERVIEWER_CALENDAR':
      return {
        ...state,
        interviewerCalendar: action.payload,
      };
    case 'SET_INTERVIEWER_EMAIL_ENABLED':
      return {
        ...state,
        interviewerEmailEnabled: action.payload,
        ...(action.payload ? {} : { interviewerEmailAttachments: [] }),
      };
    case 'SET_INTERVIEWER_EMAIL':
      return {
        ...state,
        interviewerEmail: action.payload,
      };
    case 'SET_INTERVIEWER_EMAIL_ATTACHMENTS':
      return { ...state, interviewerEmailAttachments: action.payload };
    case 'SET_SELF_SCHEDULE_ENABLED':
      return {
        ...state,
        selfScheduleEnabled: action.payload,
        ...(action.payload ? {} : { selfScheduleAttachments: [] }),
      };
    case 'SET_SELF_SCHEDULE':
      return {
        ...state,
        selfSchedule: action.payload,
      };
    case 'SET_SELF_SCHEDULE_ATTACHMENTS':
      return { ...state, selfScheduleAttachments: action.payload };
    case 'SET_CANDIDATE_ICS_ENABLED':
      return { ...state, candidateIcsEnabled: action.payload };
    case 'SET_INTERVIEWER_ICS_ENABLED':
      return { ...state, interviewerIcsEnabled: action.payload };
    case 'REPLACE_ALL':
      return action.payload;
    default:
      return state;
  }
}
